module.exports = __webpack_public_path__ + "images/emoji/information_source.b8be59132a1fd4835b12.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/information_source.png
// module id = 798P
// module chunks = 24